import { mountFrontend } from '@sibarth/frontend';
import '@sibarth/frontend/fonts.css';
import '@sibarth/frontend/style.css';

mountFrontend({
  elementId: 'frontend-app',
});
